import { useAvailableHeight as _useAvailableHeight } from '@aevue/components'

// Wrapper con default footerSelector specifico di poderi2
export function useAvailableHeight(elementRef, options = {}) {
  return _useAvailableHeight(elementRef, {
    footerSelector: '.poderi-footer',
    ...options,
  })
}
